<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-04-18 15:31:10
 * @LastEditors: Please set LastEditors
 * @Description:实时抓拍图片
-->
<template>
  <div class="pictureCard">
    <div class="eareItem" v-for="(item, index) in eareInfoList" :key="index">
      <div
        class="eareItemImg"
        @mouseover="handleMoreOperation(item, index)"
        @mouseleave="handleMoreLeave(item)"
      >
        <img v-if="item.base64" :src="item.base64" fit="cover" />
        <!-- <div class="downBtn" v-show="!moreFalse">下载</div> -->
        <div class="moreBtn" @click="moreClick">
          <!-- 更多操作 -->
          <i
            :class="['iconfont', 'icon-zhuangbei']"
            v-show="item.faceId == showEareItem && moreOperation"
          ></i>
          <div
            class="moreSelect"
            v-show="item.faceId == showEareItem && moreFalse"
          >
            <div
              class="moreList"
              v-show="!it.show"
              v-for="(it, ind) in moreSelectList"
              :key="ind"
              @click="moreSelectClick(it, item)"
            >
              <i :class="['iconfont', it.icon]"></i>
              {{ it.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="eareFont">
        <div class="bluebg"></div>
        {{ item.name }}
      </div>
    </div>
  </div>
  <h-big-picture
    :pictureUrl="pictureUrl"
    v-model:visible="bigPictureVisible"
  ></h-big-picture>
</template>
<script >
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  useSlots,
  watchEffect,
} from "vue";
import {
  urlToBase,
  addrTrans,
} from "@/api/smartApplication/personSearchApi.js";
import { useRouter } from "vue-router";
import util from "@util/js";
export default defineComponent({
  name: "pictureCard",
  components: {},
  props: {
    pictureInfo: {
      type: Object,
      default: [],
    },
  },
  setup(props) {
    const router = useRouter();
    const data = reactive({
      moreFalse: false,
      moreOperation: false, // 展示更多操作
      showEareItem: "1",
      base64Str: "data:image/png;base64,",
      eareInfoList: [
        {
          name: "涉黄整治",
          value: "1",
          url: require("@/assets/images/boticon.png"),
        },
        {
          name: "涉毒抓拍",
          value: "2",
          url: require("@/assets/images/boticon.png"),
        },
        {
          name: "追逃布控",
          value: "3",
          url: require("@/assets/images/boticon.png"),
        },
      ],
      moreSelectList: [
        { name: "查看大图", icon: "icon-fangda", path: "" },
        { name: "下载", value: "icon-shexiangtou1", path: "" },
        {
          name: "身份稽查",
          value: "icon-shenfenzheng",
          path: "",
          show: window.outNetwork,
        },
        // {
        //   name: "落脚点分析",
        //   value: "icon-navigation_e",
        //   path: "",
        //   show: window.outNetwork,
        // },
        {
          name: "视图研判",
          value: "icon-yanpanmoxing",
          path: "",
          show: window.outNetwork,
        },
        {
          name: "同行分析",
          value: "icon-bansuitongxi",
          path: "",
          show: window.outNetwork,
        },
        {
          name: "抓拍检索",
          value: "icon-biaoshilei_luxiang",
          path: "",
          show: window.outNetwork,
        },
        {
          name: "1比1比对",
          value: "icon-beijingyibiyi",
          path: "",
          show: window.outNetwork,
        },
      ],
      pictureUrl: null,
      bigPictureVisible: false,
    });
    const refData = toRefs(data);
    watchEffect(() => {
      console.log(props.pictureInfo);
      data.eareInfoList = props.pictureInfo;
      nextTick(() => {
        data.eareInfoList.forEach((item) => {
          urlToBase64(item);
        });
      });
    });
    const urlToBase64 = async (val) => {
      // let url = val.partUrlRelative;
      // const res = await urlToBase({ url: url });
      const path = {
        paths: [val.partUrlRelative],
      };
      const res = await addrTrans(path);
      val.base64 = res.data;
    };
    // 点击展示更多菜单
    const moreClick = (item) => {
      data.moreFalse = !data.moreFalse;
    };
    // 点击菜单中item
    const moreSelectClick = (it, item) => {
      let newPage
      if (it.name === "查看大图") {
        bigPicture(item.imageUrl);
      } else if (it.name === "下载") {
        const url = "/imgApi/?" + item.imageUrl.split("/?")[1];
        util.downImgFile(url);
        // util.downImgFile(data.base64Str + item.base64);
      } else if (it.name === "身份稽查") {
        router.push({
          path: "identityCheck",
          query: { img: item.imagePartUrl },
        });
      } else if (it.name === "落脚点分析") {
        router.push({
          path: "footholdAnalysis",
          query: { img: item.imagePartUrl },
        });
      } else if (it.name === "视图研判") {
        newPage =  router.resolve({
          path: "trackQuery",
          query: { img: item.imagePartUrl },
        });
      } else if (it.name === "同行分析") {
        router.push({
          path: "peerAnalysis",
          query: { img: item.imagePartUrl },
        });
      } else if (it.name === "抓拍检索") {
        router.push({
          path: "personSearch",
          query: { img: item.imagePartUrl },
        });
      } else if (it.name === "1比1比对") {
        router.push({
          path: "faceContrast",
          query: { img: item.imagePartUrl },
        });
      }
      if(newPage) window.open(newPage.href,'_blank')
    };
    const handleMoreOperation = (item) => {
      data.moreOperation = true;
      data.showEareItem = item.faceId;
      //  data.showEareItem = item.value;
    };
    const handleMoreLeave = () => {
      data.moreOperation = false;
      data.moreFalse = false;
    };
    const bigPicture = (url) => {
      data.pictureUrl = url;
      data.bigPictureVisible = true;
    };
    return {
      ...refData,
      moreClick,
      handleMoreOperation,
      handleMoreLeave,
      moreSelectClick,
    };
  },
});
</script>
<style  lang='scss' scoped >
.pictureCard {
  width: 100%;
  display: flex;
  margin: 10px 0;
  justify-content: space-evenly;
  .eareItem {
    display: flex;
    flex-direction: column;
    font-size: 16px;

    .eareItemImg {
      position: relative;
      width: 100px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
      .downBtn {
        padding: 3px 5px;
        background: rgba(0, 0, 0, 0.5);
        // border-radius: 5px;
        position: absolute;
        width: 100%;
        top: 0;
        text-align: center;
        cursor: pointer;
      }
      .moreBtn {
        position: absolute;
        width: 100%;
        text-align: center;
        background: rgba(0, 0, 0, 0.5);
        bottom: 0px;
        cursor: pointer;
      }
    }

    .eareFont {
      display: flex;
      align-items: center;
      margin-top: 6px;
      .bluebg {
        width: 5px;
        height: 5px;
        margin-right: 10px;
        background-color: #73f1f3;
      }
    }
  }
  .moreSelect {
    position: absolute;
    font-size: 14px;
    bottom: 21px;
    background: rgba(0, 0, 0, 1);
    width: 100%;
    line-height: 28px;
    cursor: pointer;
  }
}
</style>